export default __webpack_public_path__ + "static/media/ListQr_icon_disabled.61e74665.svg";